import { JSX } from 'react'

export function AppGlobalError(): JSX.Element {
  return <div>Une erreur est survenu dans l'application</div>
}
